import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

if (!supabaseUrl || !supabaseKey) {
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Test helper stubs - replaced by __mocks__/supabase.ts during tests
export const resetSupabaseMocks = () => {};
export const setAuthMockResponse = (_method: string, _response: unknown) => {};
export const createQueryBuilder = () => ({});
export const setMockResponse = (
  _table: string,
  _method: string,
  _response: unknown
) => {};
